export const positionTypes = [
  'Bond',
  'Cap',
  'Certificate',
  'CreditFacility',
  'Loan',
  'Swap',
];

export const emptyGuid = '00000000-0000-0000-0000-000000000000';

export const anyGuid = '99999999-9999-9999-9999-999999999999';

export const fieldMemberDelimiters = [
  { value: 'Empty', representation: '' },
  { value: 'Space', representation: '⎵' },
  { value: 'Hyphen', representation: '–' },
  { value: 'Underscore', representation: '_' },
];

export const ACCT_ACCESS_PERMISSION = 'AccountingAccess';
export const ACCT_ASSIGN_PERMISSION = 'AcctAssign';
export const ACCT_FILE_PERMISSION = 'AcctFile';
export const ACCT_ADMIN_PERMISSION = 'AcctAdmin';
